module.exports = __webpack_public_path__ + "static/media/master_white.268602da.png";